// src/config.ts
var PRICING_CONFIG = {
  ["EUR" /* EUR */]: {
    yearlyDiscountPercent: 20,
    tiers: [
      { maxRooms: 10, yearlyPrice: 10 },
      // Monthly: 12.50
      { maxRooms: 49, yearlyPrice: 6 },
      // Monthly: 7.50
      { maxRooms: 99, yearlyPrice: 5 },
      // Monthly: 6.25
      { maxRooms: 149, yearlyPrice: 4.5 },
      // Monthly: 5.625
      { maxRooms: 249, yearlyPrice: 4 },
      // Monthly: 5.00
      { maxRooms: Infinity, yearlyPrice: 3.5 }
      // Monthly: 4.375
    ]
  },
  ["THB" /* THB */]: {
    yearlyDiscountPercent: 20,
    tiers: [
      { maxRooms: 10, yearlyPrice: 300 },
      // Monthly: 375
      { maxRooms: 49, yearlyPrice: 200 },
      // Monthly: 250
      { maxRooms: 99, yearlyPrice: 150 },
      // Monthly: 187.50
      { maxRooms: 149, yearlyPrice: 140 },
      // Monthly: 175
      { maxRooms: 249, yearlyPrice: 125 },
      // Monthly: 156.25
      { maxRooms: Infinity, yearlyPrice: 110 }
      // Monthly: 137.50
    ]
  },
  ["AUD" /* AUD */]: {
    yearlyDiscountPercent: 20,
    tiers: [
      { maxRooms: 10, yearlyPrice: 15 },
      // Monthly: 18.75
      { maxRooms: 49, yearlyPrice: 10 },
      // Monthly: 12.50
      { maxRooms: 99, yearlyPrice: 8 },
      // Monthly: 10.00
      { maxRooms: 149, yearlyPrice: 7.5 },
      // Monthly: 9.375
      { maxRooms: 249, yearlyPrice: 6.5 },
      // Monthly: 8.125
      { maxRooms: Infinity, yearlyPrice: 6 }
      // Monthly: 7.50
    ]
  },
  ["GBP" /* GBP */]: {
    yearlyDiscountPercent: 20,
    tiers: [
      { maxRooms: 10, yearlyPrice: 8 },
      // Monthly: 10.00
      { maxRooms: 49, yearlyPrice: 5 },
      // Monthly: 6.25
      { maxRooms: 99, yearlyPrice: 4.5 },
      // Monthly: 5.625
      { maxRooms: 149, yearlyPrice: 4 },
      // Monthly: 5.00
      { maxRooms: 249, yearlyPrice: 3.5 },
      // Monthly: 4.375
      { maxRooms: Infinity, yearlyPrice: 3 }
      // Monthly: 3.75
    ]
  },
  ["CHF" /* CHF */]: {
    yearlyDiscountPercent: 20,
    tiers: [
      { maxRooms: 10, yearlyPrice: 9 },
      // Monthly: 11.25
      { maxRooms: 49, yearlyPrice: 6 },
      // Monthly: 7.50
      { maxRooms: 99, yearlyPrice: 5 },
      // Monthly: 6.25
      { maxRooms: 149, yearlyPrice: 4.5 },
      // Monthly: 5.625
      { maxRooms: 249, yearlyPrice: 4 },
      // Monthly: 5.00
      { maxRooms: Infinity, yearlyPrice: 3.5 }
      // Monthly: 4.375
    ]
  }
};

// src/index.ts
var PricingType = /* @__PURE__ */ ((PricingType2) => {
  PricingType2["Monthly"] = "MONTHLY";
  PricingType2["Yearly"] = "YEARLY";
  return PricingType2;
})(PricingType || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["EUR"] = "EUR";
  Currency2["THB"] = "THB";
  Currency2["AUD"] = "AUD";
  Currency2["GBP"] = "GBP";
  Currency2["CHF"] = "CHF";
  return Currency2;
})(Currency || {});
var COUNTRY_TO_CURRENCY = {
  TH: "THB" /* THB */,
  AU: "AUD" /* AUD */,
  GB: "GBP" /* GBP */,
  CH: "CHF" /* CHF */
};
function price(type, amountOfRooms, currency = "EUR" /* EUR */) {
  if (!Object.values(PricingType).includes(type)) {
    throw new Error(
      `Invalid pricing type: ${type}. Must be 'MONTHLY' or 'YEARLY'.`
    );
  }
  if (!Number.isInteger(amountOfRooms) || amountOfRooms <= 0) {
    throw new Error("Amount of rooms must be a positive integer.");
  }
  if (!Object.values(Currency).includes(currency)) {
    throw new Error(
      `Invalid currency: ${currency}. Must be one of: ${Object.values(Currency).join(", ")}.`
    );
  }
  const currencyConfig = PRICING_CONFIG[currency];
  const tier = currencyConfig.tiers.find(
    (t) => amountOfRooms <= t.maxRooms
  );
  if (!tier) {
    throw new Error("No pricing tier found for room count.");
  }
  let unitPriceInMainUnit = tier.yearlyPrice;
  if (type === "MONTHLY" /* Monthly */) {
    const markupMultiplier = 1 - currencyConfig.yearlyDiscountPercent / 100;
    unitPriceInMainUnit = tier.yearlyPrice / markupMultiplier;
  }
  const unitPrice = Math.round(unitPriceInMainUnit * 100);
  const totalPrice = unitPrice * amountOfRooms;
  const roomsWithLowestPrice = currencyConfig.tiers[currencyConfig.tiers.length - 2].maxRooms + 1;
  return { unitPrice, totalPrice, currency, roomsWithLowestPrice };
}
function detectCurrencyFromLocation() {
  return fetch("https://cloudflare.com/cdn-cgi/trace", {
    cache: "no-store"
  }).then((response) => Promise.resolve(response.text())).then((data) => {
    const countryCode = data.match(/loc=([A-Z]{2})/)?.[1];
    const currency = countryCode ? COUNTRY_TO_CURRENCY[countryCode] : "EUR" /* EUR */;
    return Promise.resolve(currency ?? "EUR" /* EUR */);
  });
}
export {
  Currency,
  PricingType,
  detectCurrencyFromLocation,
  price
};
//# sourceMappingURL=index.js.map